import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BSkeleton } from "bootstrap-vue";
import { ref } from "vue";
import { GalaxyApi } from "@/api";
import { useMarkdown } from "@/composables/markdown";
import { errorMessageAsString } from "@/utils/simple-error";
import LoadingSpan from "./LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GalaxyWizard',
    props: {
        context: { default: "username" },
        jobId: null,
        query: null,
        view: { default: "error" }
    },
    setup(__props) {
        const props = __props;
        library.add(faThumbsUp, faThumbsDown);
        const query = ref(props.query);
        const queryResponse = ref("");
        const errorMessage = ref("");
        const busy = ref(false);
        const feedback = ref(null);
        const hasError = ref(false);
        const { renderMarkdown } = useMarkdown({ openLinksInNewPage: true, removeNewlinesAfterList: true });
        /** On submit, query the server and put response in display box **/
        async function submitQuery() {
            busy.value = true;
            hasError.value = false;
            errorMessage.value = "";
            queryResponse.value = "";
            if (query.value === "") {
                errorMessage.value = "There is no context to provide a response.";
                busy.value = false;
                return;
            }
            const { data, error } = await GalaxyApi().POST("/api/chat", {
                params: {
                    query: { job_id: props.jobId },
                },
                body: {
                    query: query.value,
                    context: props.context,
                },
            });
            if (error) {
                errorMessage.value = errorMessageAsString(error, "Failed to get response from the server.");
                hasError.value = true;
            }
            else {
                if (data.response) {
                    queryResponse.value = data.response;
                }
                // If there's an error code or message, set the error flag and message
                if (data.error_code || data.error_message) {
                    hasError.value = true;
                    if (data.error_code && data.error_message) {
                        errorMessage.value = `${data.error_message} (Error ${data.error_code})`;
                    }
                    else if (data.error_message) {
                        errorMessage.value = data.error_message;
                    }
                    else if (data.error_code) {
                        errorMessage.value = `Error ${data.error_code}`;
                    }
                }
            }
            busy.value = false;
        }
        /** Send feedback to the server **/
        async function sendFeedback(value) {
            feedback.value = value;
            // up is 1 and down is 0
            const feedbackValue = value === "up" ? 1 : 0;
            const { error } = await GalaxyApi().PUT("/api/chat/{job_id}/feedback", {
                params: {
                    path: { job_id: props.jobId },
                    query: { feedback: feedbackValue },
                },
            });
            if (error) {
                errorMessage.value = errorMessageAsString(error, "Failed to send feedback to the server.");
            }
        }
        return { __sfc: true, props, query, queryResponse, errorMessage, busy, feedback, hasError, renderMarkdown, submitQuery, sendFeedback, faThumbsDown, faThumbsUp, FontAwesomeIcon, BButton, BSkeleton, LoadingSpan };
    }
});
